import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import API from 'configs/API';
import { axiosGet } from 'utils/apis/axios';

import ArtistAbout from './components/ArtistAbout';
import ArtistStatements from './components/ArtistStatements';
import Awards from './components/Awards';
import Biography from './components/Biography';
import Collection from './components/Collection';
import Exhibitions from './components/Exhibitions';
import Publications from './components/Publications';
import useStyles from './styles';

const ArtistProfileColRight = ({ userProfile, artistUuid }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [listAward, setListAward] = useState([]);
  const [listSoloExhibition, setListSoloExhibition] = useState([]);
  const [listGroupExhibition, setListGroupExhibition] = useState([]);
  const [listPublication, setListPublication] = useState([]);
  const [listCollection, setListCollection] = useState([]);

  const fetchData = async (apiEndpoint, stateUpdater) => {
    const { success, data } = await axiosGet(apiEndpoint, {
      params: {
        is_public: true,
        user_uuid: artistUuid,
      },
    });
    if (success) {
      stateUpdater(data);
    }
  };

  useEffect(() => {
    Promise.all([
      fetchData(API.AUTH.AWARD.LIST, setListAward),
      fetchData(API.AUTH.SOLO_EXHIBITION.LIST, setListSoloExhibition),
      fetchData(API.AUTH.GROUP_EXHIBITION.LIST, setListGroupExhibition),
      fetchData(API.AUTH.PUBLICATION.LIST, setListPublication),
      fetchData(API.AUTH.COLLECTION.LIST, setListCollection),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.wrapColRight}>
      <ArtistStatements statement={userProfile?.introduction} />

      <ArtistAbout aboutArtist={userProfile?.about_artist} />

      <Biography userProfile={userProfile} />

      <Awards listAward={listAward} />

      <Exhibitions
        listExhibition={listSoloExhibition}
        textExhibition={t('solo_exhibitions')}
      />
      <Exhibitions
        listExhibition={listGroupExhibition}
        textExhibition={t('group_exhibitions')}
      />

      <Publications listPublication={listPublication} />
      <Collection listCollection={listCollection} />
    </div>
  );
};

export default ArtistProfileColRight;
